import axios from 'axios'
import qs from 'qs'
import _ from 'lodash'
import Cookies from '@/until/cookie'
import Until from '@/until/until'
export default (function () {
    let NODE_TEST = process.env.HOST
    console.log('NODE_TEST', NODE_TEST)
    const COOKIE_PREFIX = 'MeM_'
    const PLATFORM = Until.platForm()
    const SEARCH_PARAM = Until.searchParam()
    const ON_API_EXTEND = { ERROR () {} }
    const OPTIONS = {
        // BASEURL: 'https://ssma.echao.com',
        BASEURL: 'https://ssma.echao.com',
        APILIST: ['getLocation', 'onMenuShareTimeline', 'onMenuShareAppMessage', 'chooseImage', 'previewImage', 'getLocalImgData', 'getNetworkType', 'openLocation', 'closeWindow', 'hideMenuItems', 'showMenuItems', 'hideAllNonBaseMenuItem', 'showAllNonBaseMenuItem', 'scanQRCode', 'stopRecord', 'startRecord', 'onVoiceRecordEnd', 'playVoice', 'onVoicePlayEnd', 'pauseVoice', 'stopVoice', 'uploadVoice', 'downloadVoice'],
        MENUITEM: ['menuItem:share:appMessage', 'menuItem:share:timeline', 'menuItem:share:qq', 'menuItem:share:weiboApp', 'menuItem:favorite', 'menuItem:share:facebook', 'menuItem:share:QZone', 'menuItem:editTag', 'menuItem:delete', 'menuItem:copyUrl', 'menuItem:originPage', 'menuItem:readMode', 'menuItem:openWithQQBrowser', 'menuItem:openWithSafari', 'menuItem:share:email', 'menuItem:share:brand'],
        MEMBER_BASE: {
            PORT: null,
            FANS: {},
            GROUP: {},
            CUSTOMER: {}
        },
        AUTH_URL: ''
    }

    axios.defaults.timeout = 120000
    axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
    // axios.defaults.baseURL = OPTIONS.BASEURL + (NODE_TEST === 'test' ? '/crmceshi/' : '/lyj/')
    axios.defaults.baseURL = OPTIONS.BASEURL + (NODE_TEST === 'test' ? '/lyj/' : '/lyj/')
    axios.interceptors.request.use((config) => {
        if (config.method === 'post') {
            config.data = qs.stringify(config.data)
        }
        return config
    }, (error) => { return Promise.reject(new TypeError(error)) })

    function api (path, param) {
        return new Promise((resolve) => {
            const query = Object.assign({}, param || {})
            let authAuthRedirect = false
            if (!Object.prototype.hasOwnProperty.call(query, 'access_token')) {
                query.access_token = Cookies.get(COOKIE_PREFIX + 'access_token')
                // query.access_token = localStorage.getItem('staff:access-token')
                authAuthRedirect = true
            }
            return axios.post(path, query).then((res) => {
                res.request_param = query
                try {
                    if (parseInt(res.data.error_code, 10) === 300 && authAuthRedirect) {
                        resolve(res)
                        return onAuthRedirect()
                    }
                } catch (e) {}
                resolve(res)
            }).catch((err) => {
                resolve({error_code: 404, error_msg: err.message, data: null})
            })
        })
    }

    function onGetUrl (filter, query) {
        const currentUrl = window.location.href.split('?')[0]
        const coverParam = Object.assign(SEARCH_PARAM, (_.isPlainObject(query) ? query : {}))
        let assembleParam = {}
        let redirectQueryString = ''
        if (Object.keys(coverParam).length) {
            let filterParam = (_.isArray(filter) ? filter : []).concat(['isappinstalled', 'from', 'code', 'uuid', 'oauth_token'])
            for (var index in coverParam) {
                if (filterParam.indexOf(index) !== -1) {
                    continue // 过滤掉链接里的某些GET参数
                }
                redirectQueryString += (redirectQueryString ? '&' : '?') + index
                if (coverParam[index]) {
                    redirectQueryString += '=' + coverParam[index]
                    assembleParam[index] = coverParam[index]
                }
            }
        }
        return [currentUrl, redirectQueryString, currentUrl + redirectQueryString, assembleParam]
    }

    // 注销登录
    function onRemoveToken () {
        Cookies.remove(COOKIE_PREFIX + 'access_uid', {path: '/'})
        Cookies.remove(COOKIE_PREFIX + 'access_code', {path: '/'})
        Cookies.remove(COOKIE_PREFIX + 'access_token', {path: '/'})
        Cookies.remove(COOKIE_PREFIX + 'access_expires', {path: '/'})
    }

    // 设置 token
    function onSetToken (uid, code, token, expires) {
        const expiresTime = new Date(expires * 1000)
        Cookies.set(COOKIE_PREFIX + 'access_uid', uid, { expires: expiresTime, path: '/' })
        Cookies.set(COOKIE_PREFIX + 'access_code', code, { expires: expiresTime, path: '/' })
        Cookies.set(COOKIE_PREFIX + 'access_token', token, { expires: expiresTime, path: '/' })
        Cookies.set(COOKIE_PREFIX + 'access_expires', expires, { expires: expiresTime, path: '/' })
        return expiresTime
    }

    function onAuthRedirect (filter, query) {
        onRemoveToken()
        try {
            if (!PLATFORM.isWx) {
                ON_API_EXTEND.ERROR('please_use_wechat_to_open_it')
                return false
            }
            let queryString = '?origin_id=' + OPTIONS.router.route.params.ShareId// 邀请人的ID
                queryString += '&force_refresh=1' // 是否强制刷新授权
                queryString += '&redirect_url=' + encodeURIComponent(onGetUrl()[2]) // 跳转回调
                queryString += '&user_id=' + parseInt(OPTIONS.router.route.params.Uid, 10) || 0 // 回调平台ID 跳转
                queryString += '&acid=' + parseInt(OPTIONS.WEB_AUTH_ACID, 10) // 回调平台ID 跳转
                queryString += '&async_id=' + parseInt(OPTIONS.WEB_AUTH_ASYNC_ID, 10) // 回调平台ID 异步
            // if (confirm('是否强制刷新授权')) {
                // window.location.href = 'https://ssma.echao.com/oauth/' + queryString
            // }
            window.location.href = 'https://ssma.echao.com/oauth/' + queryString
            return true
        } catch (e) {
            ON_API_EXTEND.ERROR(e.message)
            return false
        }
    }

    function onGetWeChatConfig () {
        let param = {}
        try {
            param.user_id = parseInt(OPTIONS.router.route.params.Uid, 10) || 0
        } catch (e) { }
        if (!param.user_id) {
            return ON_API_EXTEND.ERROR('no_available_ports_were_found')
        }
        return new Promise((resolve) => {
            if (parseInt(OPTIONS.WEB_AUTH_ACID, 10) > 0) {
                return resolve(true)
            }
            api('Api/User/getWeChatConfig', param).then((body) => {
                if (body.data && body.data.data && !body.data.error_code) {
                    let dataIndex = 0
                    const dataMap = Object.keys(body.data.data)
                    for (; dataIndex < dataMap.length; dataIndex += 1) {
                        OPTIONS[dataMap[dataIndex].toUpperCase()] = body.data.data[dataMap[dataIndex]]
                    }
                }
                resolve(parseInt(OPTIONS.WEB_AUTH_ACID, 10) > 0)
            })
        })
    }

    function queryAssemble (routeName, customerId, fansId) {
        const memberString = PLATFORM.isWx ? ('FS' + (parseInt(fansId, 10) || 0)) : ('CS' + (parseInt(customerId, 10) || 0))
        const hasAssembleMember = Object.prototype.hasOwnProperty.call(OPTIONS.router.route.query, 'member')
        if (!hasAssembleMember || (hasAssembleMember && (OPTIONS.router.route.query.member || '').toUpperCase() !== memberString)) {
            const query = Object.assign({}, OPTIONS.router.route.query, {member: memberString, rand: Math.random()})
            const param = _.clone(OPTIONS.router.route.params)
            const shareMap = ((param.ShareId || '').replace(new RegExp(memberString + '|FS0|CS0', 'ig'), '') + memberString).toUpperCase().match(/([A-Z]{1,}\d+)/ig)
            let shareIndex = 0
            let shareFilter = []
            for (; shareIndex < shareMap.length; shareIndex += 1) {
                if (shareFilter.indexOf(shareMap[shareIndex]) === -1) {
                    shareFilter.push(shareMap[shareIndex])
                }
            }
            param.ShareId = shareFilter.join('')
            return {name: routeName, params: param, query: query}
        }
        return null
    }

    api.use = (name, value) => {
        const useDatabaseName = (name).toLowerCase()
        OPTIONS[useDatabaseName] = value
    }
    api.on = (name, callback) => {
        const apiExtendName = (name).toUpperCase()
        if (Object.prototype.hasOwnProperty.call(ON_API_EXTEND, apiExtendName)) {
            ON_API_EXTEND[apiExtendName] = _.isFunction(callback) ? callback : function () {}
        }
    }
    api.stopHistory = (currentPath, isForce) => {
        if (window.SSM_BIND_EVENTLISTENER_POPSTATE && isForce !== true) {
            return null
        }
        window.SSM_BIND_EVENTLISTENER_POPSTATE = true
        let bindUrl = onGetUrl([], {rand: Math.random()})[2]
        if (currentPath) {
            if (currentPath === true) {
                currentPath = OPTIONS.router.route.fullPath.match(OPTIONS.router.route.matched[0].regex).slice(1).join('/')
            }
            bindUrl = Until.protocol() + '://' + (document ? document.domain : window.location.hostname) + (window.location.port ? ':' + window.location.port : '') + (currentPath.indexOf('/') === 0 ? '' : '/') + currentPath
            window.SSM_BIND_EVENTLISTENER_POPSTATE = currentPath
        }
        console.log(bindUrl)
        window.history.pushState(null, null, bindUrl)
        window.addEventListener('popstate', (event) => {
            history.pushState(null, null, bindUrl) // 使用pushState插入一条历史记录 防止页面后退
        })
    }
    api.isBeBack = () => {
        if (window.SSM_BIND_EVENTLISTENER_POPSTATE !== true && window.SSM_BIND_EVENTLISTENER_POPSTATE === OPTIONS.router.route.fullPath) {
            return false
        }
        return true
    }
    api.weChatJsdk = (showMenuItems) => {
        let menuItem = {show: [], hide: []}
        let menuIndex = 0
        let showMenu = showMenuItems && _.isArray(showMenuItems) && showMenuItems.length
        for (; menuIndex < OPTIONS.MENUITEM.length; menuIndex += 1) {
            let menuName = OPTIONS.MENUITEM[menuIndex]
            if (showMenu && showMenuItems.indexOf(menuName) >= 0) {
                menuItem.show.push(menuName)
                continue
            }
            menuItem.hide.push(menuName)
        }
        return new Promise((resolve) => {
            if (PLATFORM.isWx && wx instanceof Object) {
                return setTimeout(() => {
                    if (PLATFORM.isIOS && OPTIONS.IOS_WECHAT_JSDK === true) {
                        wx.hideMenuItems({ menuList: menuItem.hide }) // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
                        wx.showMenuItems({ menuList: menuItem.show }) // 要显示的菜单项，所有menu项见附录3
                        return resolve(PLATFORM)
                    }
                    const param = {
                        acid: parseInt(OPTIONS.WEB_AUTH_ACID, 10),
                        url: PLATFORM.isIOS && OPTIONS.AUTH_URL ? encodeURIComponent(OPTIONS.AUTH_URL) : encodeURIComponent(window.location.href.split('#')[0])
                    }
                    return api(OPTIONS.BASEURL + '/oauth/jssdk.php', param).then((body) => {
                        if (body.data && parseInt(body.data.status, 10) === 1) {
                            wx.config({
                                debug: false,
                                appId: body.data.info.appId,
                                timestamp: body.data.info.timestamp,
                                nonceStr: body.data.info.nonceStr,
                                signature: body.data.info.signature,
                                jsApiList: OPTIONS.APILIST
                            })
                            let wxConfigState = 0
                            wx.error((res) => {
                                wxConfigState = 1
                                OPTIONS.IOS_WECHAT_JSDK = false
                                console.log(res)
                                resolve(false, res)
                            })
                            wx.ready(() => {
                                if (!wxConfigState) {
                                    OPTIONS.IOS_WECHAT_JSDK = true
                                    wx.hideMenuItems({ menuList: menuItem.hide }) // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
                                    wx.showMenuItems({ menuList: menuItem.show }) // 要显示的菜单项，所有menu项见附录3
                                    return resolve(PLATFORM)
                                }
                            })
                            return true
                        }
                        return resolve(false)
                    })
                }, 500)
            }
            return resolve(PLATFORM)
        })
    }
    api.loginWrite = (data) => {
        const Uid = parseInt(OPTIONS.router.route.params.Uid, 10) || 0
        if (onSetToken(Uid, data.access_code, data.access_token, data.expires_time)) {
            return OPTIONS.router
        }
        return null
    }
    api.loginExist = () => {
        const currentTime = parseInt((new Date()).getTime() / 1000, 10)
        const accessToken = Cookies.get(COOKIE_PREFIX + 'access_token')
        const accessExpires = Cookies.get(COOKIE_PREFIX + 'access_expires')
        if (accessToken && accessExpires > currentTime) {
            return true
        }
        return false
    }
    api.aliSts = () => {
        return new Promise((resolve) => {
            const currentTime = parseInt((new Date()).getTime() / 1000, 10)
            if (!OPTIONS.aliSts || !_.isPlainObject(OPTIONS.aliSts) || OPTIONS.aliSts.expiration <= currentTime) {
                return api('Api/AliSts/Token', {}).then((body) => {
                    if (body.data && body.data.data && !body.data.error_code) {
                        OPTIONS.aliSts = body.data.data
                    }
                    resolve(OPTIONS.aliSts)
                })
            }
            resolve(OPTIONS.aliSts)
        })
    }
    api.aliStsPublic = (param) => {
        return new Promise((resolve) => {
            const currentTime = parseInt((new Date()).getTime() / 1000, 10)
            if (!OPTIONS.aliSts || !_.isPlainObject(OPTIONS.aliSts) || OPTIONS.aliSts.expiration <= currentTime) {
                return api('Api/AliSts/PublicAuth', param || {}).then((body) => {
                    if (body.data && body.data.data && !body.data.error_code) {
                        OPTIONS.aliSts = body.data.data
                    }
                    resolve(OPTIONS.aliSts)
                })
            }
            resolve(OPTIONS.aliSts)
        })
    }

    api.getOptions = () => {
        const data = _.clone(OPTIONS)
        return data
    }
    api.getMember = (routeName, isForce) => {
        return new Promise((resolve, reject) => {
            if (OPTIONS.MEMBER_BASE.PORT && isForce !== true) {
                OPTIONS.MEMBER_BASE.ASSEMBLE = queryAssemble(routeName, (OPTIONS.MEMBER_BASE.CUSTOMER || {}).id, (OPTIONS.MEMBER_BASE.FANS || {}).id)
                return resolve(OPTIONS.MEMBER_BASE)
            }
            api('Api/Member/Ready', {}).then((body) => {
                if (!body.data || body.data.error_code) {
                    return reject(body.data.error_msg || body.data.error_code || '未知错误')
                }
                OPTIONS.MEMBER_BASE.PORT = body.data.data.port
                OPTIONS.MEMBER_BASE.FANS = body.data.data.fans
                OPTIONS.MEMBER_BASE.GROUP = body.data.data.group
                OPTIONS.MEMBER_BASE.CUSTOMER = body.data.data.customer
                OPTIONS.MEMBER_BASE.ASSEMBLE = queryAssemble(routeName, (OPTIONS.MEMBER_BASE.CUSTOMER || {}).id, (OPTIONS.MEMBER_BASE.FANS || {}).id)
                return resolve(OPTIONS.MEMBER_BASE)
            })
        })
    }
    api.ready = (done) => {
        onGetWeChatConfig().then((isSuccess) => {
            if (!isSuccess) {
                return ON_API_EXTEND.ERROR('no_available_ports_were_found')
            }
            const currentTime = parseInt((new Date()).getTime() / 1000, 10)
            const accessUid = parseInt(Cookies.get(COOKIE_PREFIX + 'access_uid'), 10) || 0
            const accessToken = Cookies.get(COOKIE_PREFIX + 'access_token')
            const accessExpires = Cookies.get(COOKIE_PREFIX + 'access_expires')
            const accessCode = SEARCH_PARAM.access_code || SEARCH_PARAM.code || ''

            if (accessUid && accessUid !== parseInt(OPTIONS.router.route.params.Uid, 10)) {
                return onAuthRedirect()
            }
            if (!accessCode && (!accessToken || !accessExpires || (accessExpires <= currentTime))) {
                // 没有找到授权信息 OR 授权信息不全 OR 授权已过期
                if (SEARCH_PARAM.uuid && SEARCH_PARAM.oauth_token) {
                    return ON_API_EXTEND.ERROR('page_authorization_failure')
                }
                return onAuthRedirect()
            } else if (!accessToken && accessCode) {
                // 刚授权过来
                const param = { uid: parseInt(OPTIONS.router.route.params.Uid, 10) || 0, access_code: accessCode }
                return api('Api/Member/Refresh', param).then((body) => {
                    if (!body.data || !body.data.data || body.data.error_code) {
                        return onAuthRedirect()
                    }
                    onSetToken(param.uid, body.data.data.access_code, body.data.data.access_token, body.data.data.expires_time)
                    return done()
                })
            }
            return done()
        })
    }
    api.error = (done) => {
        setTimeout(done, 200)
    }

    api.continued = (done) => {
        onGetWeChatConfig().then((isSuccess) => {
            return done()
        })
    }

    api.setRem = () => {
        // 初始化rem
        const html = document.getElementsByTagName('html')[0]
        let pageWidth = html.getBoundingClientRect().width
        if (window.orientation === 0 || window.orientation === 180) {
            pageWidth = pageWidth > 750 ? 750 : pageWidth
        } else {
            pageWidth = pageWidth > html.clientHeight ? html.clientHeight : pageWidth
        }
        html.style.fontSize = pageWidth / 7.5 + 'px'
        window.addEventListener('orientationchange', api.setRem, false)
        window.addEventListener('resize', api.setRem, false)
    }

    api.setAuthUrl = (url, bool) => {
        if (bool) {
            OPTIONS.AUTH_URL = url
            return
        }
        return OPTIONS.AUTH_URL
    }

    api.removeCookies = () => {
        onRemoveToken()
    }

    api.onGetUrl = onGetUrl
    return api
})()



// WEBPACK FOOTER //
// ./src/until/core.js